import Bb from 'backbone';

import BaseFormView from '../components/BaseForm';
import UserModel from '../../models/User';
import Preloader from '../../utils/Preloader';

class CoreActivateGameView extends BaseFormView {
	get className() {
		return "activate-game-page modal-overlay";
	}

	ui() {
		let ui = {
			form             : '.js-activate-game-form',
			activate         : '.js-activate',
			t_and_cs         : '.js-t-and-cs',
		};

		ui = Object.assign(ui, this.getCustomUIElements());

		return ui;
	}

	getCustomUIElements() {
		// Overwrite this if needed in extended view
		return {};
	}

	events() {
		return {
			'click @ui.activate'    : 'onClickNext',
			'change @ui.form'   : 'onChangeForm',
		};
	}

	initialize() {
		this.model = new Bb.Model();

		if (UserModel.isGameRecovered()) {
			return this.completionRedirect();
		}

		this.setListeners();
		this.setDefaultValues();
	}

	setListeners() {
		this.listenTo(UserModel, 'user:activate:success', this.onUserActivateSuccess);
		this.listenTo(UserModel, 'user:activate:fail', this.onUserActionFail);
	}

	setDefaultValues() {
		let defaultValues = {
			t_and_cs   : 0,
			errors     : undefined
		};

		defaultValues = Object.assign(defaultValues, this.getCustomDefaultValues());

		this.model.set(defaultValues);
	}

	getCustomDefaultValues() {
		// Overwrite this if needed in extended view
		return {};
	}

	getFormValues() {
		let formValues = {
			t_and_cs: this.getUI( 't_and_cs' ).filter( ':checked' ).val() ? 1 : 0,
		};

		formValues = Object.assign(formValues, this.getCustomFormValues());

		return formValues;
	}

	getCustomFormValues() {
		// Overwrite this if needed in extended view
		return {};
	}

	async submit() {
		const errors = this.validate();

		if (errors) {
			this.attachValidationErrors(errors);
			return false;
		}

		Preloader.show();

		let activateRequestBody = this.getCustomActivateRequestBody();

		await UserModel.activateUser(activateRequestBody);
	}

	getCustomActivateRequestBody() {
		// Overwrite this if needed in extended view
		return {};
	}

	onUserActivateSuccess() {
		Preloader.hide();

		this.completionRedirect();
	}

	completionRedirect() {
		// Overwrite this in extended view
	}

	onUserActionFail(errors) {
		Preloader.hide();
		const parsed_errors = errors.map(
			error => error.text
		);
		this.attachValidationErrors({
			server_side: parsed_errors
		});
	}

	validationRules() {
		const validationRules = {
			t_and_cs: {
				exclusion: {
					within: [0],
					message: "Terms and Conditions must be checked"
				}
			}
		};

		return validationRules;
	}

	close() {
		this.destroy();
	}
}

export default CoreActivateGameView;